// src/components/TicketCard.jsx
import React from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

const TicketCard = ({ id, title, category, description, location_link, contact_number, created_at, image_url, resolved, handleClick }) => {
  const dateTime = new Date(created_at).toLocaleDateString(); // Format date
  const navigate = useNavigate();
  const currentUser = localStorage.getItem('currentUser'); // Get the logged-in user's email

  const handleEdit = (ticket) => {
    navigate(`/edit-ticket/${ticket.id}`, { state: ticket });
  };

  return (
    <div className="sm:w-[288px] w-full rounded-[15px] bg-[#1c1c24] cursor-pointer relative">
      {/* Show Edit Button Only if the Ticket Was Created by the Logged-In User */}
      {resolved === false && (
        <AiFillEdit
          className="absolute -right-5 -top-5 rounded-full bg-[#3c3ce9] h-10 w-10 p-2"
          onClick={() => handleEdit({ id, title, category, description, location_link, contact_number, created_at, image_url })}
        />
      )}

      {/* Ticket Image */}
      <img
        src={image_url ? image_url.startsWith('https') ? image_url : `${process.env.REACT_APP_BACKEND_URL}/uploads/${image_url}` : 'placeholder.png'} // Use full URL for image
        alt="ticket"
        className="w-full h-[158px] object-cover rounded-[15px]"
        onClick={handleClick}
      />

      {/* Ticket Details */}
      <div className="flex flex-col p-4" onClick={handleClick}>
        <h3 className="font-semibold text-[16px] text-white text-left leading-[26px] truncate">{title}</h3>
        <p className="mt-[3px] font-normal text-[12px] leading-[18px] text-[#808191] sm:max-w-[120px] truncate">
          Category: {category}
        </p>
        <p className="mt-[3px] font-normal text-[12px] leading-[18px] text-[#808191] sm:max-w-[120px] truncate">
          Date: {dateTime}
        </p>

        {/* Resolved/Unresolved Tag */}
        <div className="mt-2">
          {resolved ? (
            <span className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-medium">
              Resolved
            </span>
          ) : (
            <span className="bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium">
              Unresolved
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketCard;